import { MERCHANT_AGENT_CARDS, newAgentPath, STORE_AGENT_CARDS } from '@/config/agentCards'

export const dailySeries = (matching, today) => {
  const totals = new Map()
  matching.forEach(a =>
    (a.daily_conversations || []).forEach(row => {
      totals.set(row.date, (totals.get(row.date) || 0) + row.count)
    })
  )
  const days = []
  for (let i = 6; i >= 0; i--) {
    const d = new Date(today)
    d.setDate(today.getDate() - i)
    days.push(totals.get(d.toISOString().slice(0, 10)) || 0)
  }
  return days
}

// The summary agents behind a slot: a store slot takes the agents of its type
// on that store, a merchant-wide slot takes every agent of its type.
export const agentsForSlot = (slot, agents) =>
  agents.filter(
    a =>
      a.type === slot.agentType &&
      (slot.storeId === null || slot.storeId === undefined || String(a.store_id) === String(slot.storeId))
  )

export const metricsForSlot = (slot, agents, today) => {
  if (!slot.agentType) return null
  const matching = agentsForSlot(slot, agents)
  if (!matching.length) return null
  const isLive = a => a.is_active && !a.test_mode
  // Go live targets a testing agent when no agent is live.
  const target = matching.find(isLive) || matching.find(a => a.test_mode) || matching[0]
  return {
    salesDrivenCents: matching.reduce((sum, a) => sum + (a.sales_driven_cents || 0), 0),
    conversationsCount: matching.reduce((sum, a) => sum + (a.conversations_count || 0), 0),
    dailyCounts: dailySeries(matching, today),
    isActive: matching.some(isLive),
    testMode: matching.some(a => a.test_mode),
    agentId: target.id
  }
}

export const cardState = (card, metrics) => {
  if (metrics) return metrics.conversationsCount > 0 ? 'active-data' : 'active-empty'
  if (card.available) return 'setup'
  return 'coming-soon'
}

export const activeSlotCount = (slots, agents, today) =>
  slots.filter(slot => metricsForSlot(slot, agents, today)?.isActive).length

export const MERCHANT_SECTION = {
  key: 'merchant',
  title: 'Global',
  description: 'These agents work across all of your stores.'
}

const storeSlot = (card, store) => ({
  ...card,
  key: `${card.key}-${store.id}`,
  storeId: store.id,
  route: newAgentPath(card.key, store.id)
})

// The Global section with the merchant-wide cards first, then one section per
// store with the store-bound cards, each set up for that store.
export const dashboardSections = stores => [
  { ...MERCHANT_SECTION, slots: MERCHANT_AGENT_CARDS.map(card => ({ ...card, storeId: null })) },
  ...stores.map(store => ({
    key: `store-${store.id}`,
    title: store.name,
    slots: STORE_AGENT_CARDS.map(card => storeSlot(card, store))
  }))
]

export const sectionSlots = sections => sections.flatMap(section => section.slots)

// Active stores in the merchant's store order, as the Sell and Stores pages
// list them.
export const dashboardStores = storeRecords =>
  storeRecords
    .map(store => ({
      id: store.id,
      name: store.attributes.store_name || `Store #${store.id}`,
      order: store.attributes.order
    }))
    .sort((a, b) => a.order - b.order)
